import React from "react";
import { Typography } from "antd";
import Skills from "./Skills";

import "./About.css";

const { Title, Paragraph } = Typography;

function About() {
  return (
    <div className="about">
      <Skills />
      <Paragraph>
        Hey! I'm LeAnn, a computer science and engineering student at MIT. I
        will befriend anyone who brings me boba or talks to me about cdramas. I
        am passionate about software development, machine learning, and design.
        I am currently exploring the applications of computer science in finance
        and biotechnology. I am also a designer and have worked on several
        projects that involve creating user interfaces and experiences. I am
        always looking for new opportunities to learn and grow. Feel free to
        reach out to me if you want to chat!
      </Paragraph>
      {/* Add more content as needed */}
    </div>
  );
}

export default About;
